import React from "react";
import xButton from "../../assets/images/x-button.svg";

// Yes/No confirmation, styled like the delete bank / UPI popup.
export default function ConfirmPopup({
  title,
  message,
  confirmLabel = "Yes",
  cancelLabel = "No",
  onConfirm,
  onCancel,
}) {
  return (
    <div
      className="modal fade cancel-request-modal show"
      style={{ display: "block", background: "rgba(0, 0, 0, 0.8)" }}
      tabIndex="-1"
    >
      <div className="modal-dialog modal-dialog-centered delete-bank-popup">
        <div
          className="modal-content p-5"
          style={{ background: "#1D1D1D", width: "100%" }}
        >
          <i onClick={onCancel} className="bi bi-x-lg"></i>
          <div className="modal-body mobile-otp-modal--body text-center">
            <img loading="lazy" src={xButton} alt="x-button" />
            {title && (
              <p className="mt-3 mb-2" style={{ fontSize: "12px" }}>
                {title}
              </p>
            )}
            {message && <p style={{ fontSize: "10px" }}>{message}</p>}
            <div className="actions d-flex justify-content-center mt-4">
              <button className="yes-btn mx-2" onClick={onConfirm}>
                {confirmLabel}
              </button>
              <button className="no-btn mx-2" onClick={onCancel}>
                {cancelLabel}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
